// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Renderer__Settings from "@pageblocks/renderer/src/Renderer__Settings.bs.js";

function fromFloat(n) {
  return Caml_option.some(n);
}

function fromFloatOpt(__x) {
  return Core__Option.flatMap(__x, fromFloat);
}

var Size = {
  fromFloat: fromFloat,
  fromFloatOpt: fromFloatOpt
};

function fromString(alignItems) {
  switch (alignItems) {
    case "baseline" :
        return "baseline";
    case "center" :
        return "center";
    case "flex-end" :
        return "flex-end";
    case "flex-start" :
        return "flex-start";
    case "stretch" :
        return "stretch";
    default:
      return ;
  }
}

function fromStringOpt(__x) {
  return Core__Option.flatMap(__x, fromString);
}

var AlignItems = {
  fromString: fromString,
  fromStringOpt: fromStringOpt
};

function fromString$1(alignSelf) {
  switch (alignSelf) {
    case "auto" :
        return "auto";
    case "baseline" :
        return "baseline";
    case "center" :
        return "center";
    case "flex-end" :
        return "flex-end";
    case "flex-start" :
        return "flex-start";
    case "stretch" :
        return "stretch";
    default:
      return ;
  }
}

function fromStringOpt$1(__x) {
  return Core__Option.flatMap(__x, fromString$1);
}

var AlignSelf = {
  fromString: fromString$1,
  fromStringOpt: fromStringOpt$1
};

function fromString$2(fontWeight) {
  switch (fontWeight) {
    case "100" :
        return 100;
    case "200" :
        return 200;
    case "300" :
        return 300;
    case "400" :
        return 400;
    case "500" :
        return 500;
    case "600" :
        return 600;
    case "700" :
        return 700;
    case "800" :
        return 800;
    case "900" :
        return 900;
    case "bold" :
        return "bold";
    case "normal" :
        return "normal";
    default:
      return ;
  }
}

function fromStringOpt$2(__x) {
  return Core__Option.flatMap(__x, fromString$2);
}

var FontWeight = {
  fromString: fromString$2,
  fromStringOpt: fromStringOpt$2
};

function fromString$3(textDecorationLine) {
  switch (textDecorationLine) {
    case "line-through" :
        return "line-through";
    case "none" :
        return "none";
    case "underline" :
        return "underline";
    case "underline line-through" :
        return "underline line-through";
    default:
      return ;
  }
}

function fromStringOpt$3(__x) {
  return Core__Option.flatMap(__x, fromString$3);
}

var TextDecorationLine = {
  fromString: fromString$3,
  fromStringOpt: fromStringOpt$3
};

function fromString$4(justifyContent) {
  switch (justifyContent) {
    case "center" :
        return "center";
    case "flex-end" :
        return "flex-end";
    case "flex-start" :
        return "flex-start";
    case "space-around" :
        return "space-around";
    case "space-between" :
        return "space-between";
    case "space-evenly" :
        return "space-evenly";
    default:
      return ;
  }
}

function fromStringOpt$4(__x) {
  return Core__Option.flatMap(__x, fromString$4);
}

var JustifyContent = {
  fromString: fromString$4,
  fromStringOpt: fromStringOpt$4
};

function fromString$5(flexDirection) {
  switch (flexDirection) {
    case "horizontal" :
        return "row";
    case "vertical" :
        return "column";
    default:
      return ;
  }
}

function fromStringOpt$5(__x) {
  return Core__Option.flatMap(__x, fromString$5);
}

var FlexDirection = {
  fromString: fromString$5,
  fromStringOpt: fromStringOpt$5
};

function fromString$6(textAlign) {
  switch (textAlign) {
    case "auto" :
        return "auto";
    case "center" :
        return "center";
    case "justify" :
        return "justify";
    case "left" :
        return "left";
    case "right" :
        return "right";
    default:
      return ;
  }
}

function fromStringOpt$6(__x) {
  return Core__Option.flatMap(__x, fromString$6);
}

var TextAlign = {
  fromString: fromString$6,
  fromStringOpt: fromStringOpt$6
};

function fromString$7(borderStyle) {
  switch (borderStyle) {
    case "dashed" :
        return "dashed";
    case "dotted" :
        return "dotted";
    case "solid" :
        return "solid";
    default:
      return ;
  }
}

function fromStringOpt$7(__x) {
  return Core__Option.flatMap(__x, fromString$7);
}

var BorderStyle = {
  fromString: fromString$7,
  fromStringOpt: fromStringOpt$7
};

function fromString$8(position) {
  switch (position) {
    case "absolute" :
        return "absolute";
    case "relative" :
        return "relative";
    default:
      return ;
  }
}

function fromStringOpt$8(__x) {
  return Core__Option.flatMap(__x, fromString$8);
}

var Position = {
  fromString: fromString$8,
  fromStringOpt: fromStringOpt$8
};

function fromString$9(textTransform) {
  switch (textTransform) {
    case "capitalize" :
        return "capitalize";
    case "lowercase" :
        return "lowercase";
    case "none" :
        return "none";
    case "uppercase" :
        return "uppercase";
    default:
      return ;
  }
}

function fromStringOpt$9(__x) {
  return Core__Option.flatMap(__x, fromString$9);
}

var TextTransform = {
  fromString: fromString$9,
  fromStringOpt: fromStringOpt$9
};

function fromString$10(flexWrap) {
  switch (flexWrap) {
    case "nowrap" :
        return "nowrap";
    case "wrap" :
        return "wrap";
    default:
      return ;
  }
}

function fromStringOpt$10(__x) {
  return Core__Option.flatMap(__x, fromString$10);
}

var FlexWrap = {
  fromString: fromString$10,
  fromStringOpt: fromStringOpt$10
};

function padding(settings, context) {
  var getFloat = function (code) {
    return Renderer__Settings.getFloat(settings, code, context);
  };
  var __x = getFloat("paddingBottom");
  var __x$1 = getFloat("paddingLeft");
  var __x$2 = getFloat("paddingRight");
  var __x$3 = getFloat("paddingTop");
  var tmp = {};
  var tmp$1 = Core__Option.flatMap(__x, fromFloat);
  if (tmp$1 !== undefined) {
    tmp.paddingBottom = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = Core__Option.flatMap(__x$1, fromFloat);
  if (tmp$2 !== undefined) {
    tmp.paddingLeft = Caml_option.valFromOption(tmp$2);
  }
  var tmp$3 = Core__Option.flatMap(__x$2, fromFloat);
  if (tmp$3 !== undefined) {
    tmp.paddingRight = Caml_option.valFromOption(tmp$3);
  }
  var tmp$4 = Core__Option.flatMap(__x$3, fromFloat);
  if (tmp$4 !== undefined) {
    tmp.paddingTop = Caml_option.valFromOption(tmp$4);
  }
  return tmp;
}

function margin(settings, context) {
  var getFloat = function (code) {
    return Renderer__Settings.getFloat(settings, code, context);
  };
  var __x = getFloat("marginBottom");
  var __x$1 = getFloat("marginLeft");
  var __x$2 = getFloat("marginRight");
  var __x$3 = getFloat("marginTop");
  var tmp = {};
  var tmp$1 = Core__Option.flatMap(__x, fromFloat);
  if (tmp$1 !== undefined) {
    tmp.marginBottom = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = Core__Option.flatMap(__x$1, fromFloat);
  if (tmp$2 !== undefined) {
    tmp.marginLeft = Caml_option.valFromOption(tmp$2);
  }
  var tmp$3 = Core__Option.flatMap(__x$2, fromFloat);
  if (tmp$3 !== undefined) {
    tmp.marginRight = Caml_option.valFromOption(tmp$3);
  }
  var tmp$4 = Core__Option.flatMap(__x$3, fromFloat);
  if (tmp$4 !== undefined) {
    tmp.marginTop = Caml_option.valFromOption(tmp$4);
  }
  return tmp;
}

function sizing(settings, context) {
  var getFloat = function (code) {
    return Renderer__Settings.getFloat(settings, code, context);
  };
  var __x = getFloat("height");
  var __x$1 = getFloat("maxHeight");
  var __x$2 = getFloat("maxWidth");
  var __x$3 = getFloat("minHeight");
  var __x$4 = getFloat("minWidth");
  var __x$5 = getFloat("width");
  var tmp = {};
  var tmp$1 = Core__Option.flatMap(__x, fromFloat);
  if (tmp$1 !== undefined) {
    tmp.height = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = Core__Option.flatMap(__x$1, fromFloat);
  if (tmp$2 !== undefined) {
    tmp.maxHeight = Caml_option.valFromOption(tmp$2);
  }
  var tmp$3 = Core__Option.flatMap(__x$2, fromFloat);
  if (tmp$3 !== undefined) {
    tmp.maxWidth = Caml_option.valFromOption(tmp$3);
  }
  var tmp$4 = Core__Option.flatMap(__x$3, fromFloat);
  if (tmp$4 !== undefined) {
    tmp.minHeight = Caml_option.valFromOption(tmp$4);
  }
  var tmp$5 = Core__Option.flatMap(__x$4, fromFloat);
  if (tmp$5 !== undefined) {
    tmp.minWidth = Caml_option.valFromOption(tmp$5);
  }
  var tmp$6 = Core__Option.flatMap(__x$5, fromFloat);
  if (tmp$6 !== undefined) {
    tmp.width = Caml_option.valFromOption(tmp$6);
  }
  return tmp;
}

function border(settings, context) {
  var getFloat = function (code) {
    return Renderer__Settings.getFloat(settings, code, context);
  };
  var getString = function (code) {
    return Renderer__Settings.getString(settings, code, context);
  };
  var __x = getString("borderStyle");
  var tmp = {};
  var tmp$1 = getFloat("borderBottomWidth");
  if (tmp$1 !== undefined) {
    tmp.borderBottomWidth = tmp$1;
  }
  var tmp$2 = getString("borderColor");
  if (tmp$2 !== undefined) {
    tmp.borderColor = Caml_option.valFromOption(tmp$2);
  }
  var tmp$3 = getFloat("borderLeftWidth");
  if (tmp$3 !== undefined) {
    tmp.borderLeftWidth = tmp$3;
  }
  var tmp$4 = getFloat("borderRadius");
  if (tmp$4 !== undefined) {
    tmp.borderRadius = tmp$4;
  }
  var tmp$5 = getFloat("borderRightWidth");
  if (tmp$5 !== undefined) {
    tmp.borderRightWidth = tmp$5;
  }
  var tmp$6 = Core__Option.flatMap(__x, fromString$7);
  if (tmp$6 !== undefined) {
    tmp.borderStyle = Caml_option.valFromOption(tmp$6);
  }
  var tmp$7 = getFloat("borderTopWidth");
  if (tmp$7 !== undefined) {
    tmp.borderTopWidth = tmp$7;
  }
  var tmp$8 = getFloat("borderWidth");
  if (tmp$8 !== undefined) {
    tmp.borderWidth = tmp$8;
  }
  return tmp;
}

function position(settings, context) {
  var getFloat = function (code) {
    return Renderer__Settings.getFloat(settings, code, context);
  };
  var getString = function (code) {
    return Renderer__Settings.getString(settings, code, context);
  };
  var __x = getFloat("bottom");
  var __x$1 = getFloat("left");
  var __x$2 = getString("position");
  var __x$3 = getFloat("right");
  var __x$4 = getFloat("top");
  var tmp = {};
  var tmp$1 = Core__Option.flatMap(__x, fromFloat);
  if (tmp$1 !== undefined) {
    tmp.bottom = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = Core__Option.flatMap(__x$1, fromFloat);
  if (tmp$2 !== undefined) {
    tmp.left = Caml_option.valFromOption(tmp$2);
  }
  var tmp$3 = Core__Option.flatMap(__x$2, fromString$8);
  if (tmp$3 !== undefined) {
    tmp.position = Caml_option.valFromOption(tmp$3);
  }
  var tmp$4 = Core__Option.flatMap(__x$3, fromFloat);
  if (tmp$4 !== undefined) {
    tmp.right = Caml_option.valFromOption(tmp$4);
  }
  var tmp$5 = Core__Option.flatMap(__x$4, fromFloat);
  if (tmp$5 !== undefined) {
    tmp.top = Caml_option.valFromOption(tmp$5);
  }
  var tmp$6 = Core__Option.map(getFloat("zIndex"), (function (prim) {
          return prim | 0;
        }));
  if (tmp$6 !== undefined) {
    tmp.zIndex = tmp$6;
  }
  return tmp;
}

function flex(settings, context, withSpacingOpt, withFlexOpt) {
  var withSpacing = withSpacingOpt !== undefined ? withSpacingOpt : false;
  var withFlex = withFlexOpt !== undefined ? withFlexOpt : true;
  var getFloat = function (code) {
    return Renderer__Settings.getFloat(settings, code, context);
  };
  var getString = function (code) {
    return Renderer__Settings.getString(settings, code, context);
  };
  var __x = getString("alignItems");
  var __x$1 = getString("alignSelf");
  var __x$2 = getString("orientation");
  var __x$3 = getString("flexWrap");
  var __x$4 = getString("justifyContent");
  var tmp = {};
  var tmp$1 = Core__Option.flatMap(__x, fromString);
  if (tmp$1 !== undefined) {
    tmp.alignItems = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = Core__Option.flatMap(__x$1, fromString$1);
  if (tmp$2 !== undefined) {
    tmp.alignSelf = Caml_option.valFromOption(tmp$2);
  }
  var tmp$3 = withFlex ? getFloat("flex") : undefined;
  if (tmp$3 !== undefined) {
    tmp.flex = tmp$3;
  }
  var tmp$4 = Core__Option.flatMap(__x$2, fromString$5);
  if (tmp$4 !== undefined) {
    tmp.flexDirection = Caml_option.valFromOption(tmp$4);
  }
  var tmp$5 = getFloat("flexGrow");
  if (tmp$5 !== undefined) {
    tmp.flexGrow = tmp$5;
  }
  var tmp$6 = Core__Option.flatMap(__x$3, fromString$10);
  if (tmp$6 !== undefined) {
    tmp.flexWrap = Caml_option.valFromOption(tmp$6);
  }
  var tmp$7 = withSpacing ? getFloat("spacing") : undefined;
  if (tmp$7 !== undefined) {
    tmp.gap = tmp$7;
  }
  var tmp$8 = Core__Option.flatMap(__x$4, fromString$4);
  if (tmp$8 !== undefined) {
    tmp.justifyContent = Caml_option.valFromOption(tmp$8);
  }
  return tmp;
}

function background(settings, context) {
  var getFloat = function (code) {
    return Renderer__Settings.getFloat(settings, code, context);
  };
  var getString = function (code) {
    return Renderer__Settings.getString(settings, code, context);
  };
  var tmp = {};
  var tmp$1 = getString("backgroundColor");
  if (tmp$1 !== undefined) {
    tmp.backgroundColor = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = getFloat("opacity");
  if (tmp$2 !== undefined) {
    tmp.opacity = tmp$2;
  }
  return tmp;
}

function font(settings, context) {
  var getFloat = function (code) {
    return Renderer__Settings.getFloat(settings, code, context);
  };
  var getString = function (code) {
    return Renderer__Settings.getString(settings, code, context);
  };
  var __x = getString("fontWeight");
  var __x$1 = getString("textAlign");
  var __x$2 = getString("textDecorationLine");
  var __x$3 = getString("textTransform");
  var tmp = {};
  var tmp$1 = getString("color");
  if (tmp$1 !== undefined) {
    tmp.color = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = getString("fontFamily");
  if (tmp$2 !== undefined) {
    tmp.fontFamily = tmp$2;
  }
  var tmp$3 = getFloat("fontSize");
  if (tmp$3 !== undefined) {
    tmp.fontSize = tmp$3;
  }
  var tmp$4 = Core__Option.flatMap(__x, fromString$2);
  if (tmp$4 !== undefined) {
    tmp.fontWeight = Caml_option.valFromOption(tmp$4);
  }
  var tmp$5 = Core__Option.flatMap(__x$1, fromString$6);
  if (tmp$5 !== undefined) {
    tmp.textAlign = Caml_option.valFromOption(tmp$5);
  }
  var tmp$6 = Core__Option.flatMap(__x$2, fromString$3);
  if (tmp$6 !== undefined) {
    tmp.textDecorationLine = Caml_option.valFromOption(tmp$6);
  }
  var tmp$7 = Core__Option.flatMap(__x$3, fromString$9);
  if (tmp$7 !== undefined) {
    tmp.textTransform = Caml_option.valFromOption(tmp$7);
  }
  return tmp;
}

function fromString$11(ellipsizeMode) {
  switch (ellipsizeMode) {
    case "clip" :
        return "clip";
    case "head" :
        return "head";
    case "middle" :
        return "middle";
    case "tail" :
        return "tail";
    default:
      return ;
  }
}

function fromStringOpt$11(__x) {
  return Core__Option.flatMap(__x, fromString$11);
}

var EllipsizeMode = {
  fromString: fromString$11,
  fromStringOpt: fromStringOpt$11
};

function fromString$12(accessibilityRole) {
  switch (accessibilityRole) {
    case "adjustable" :
        return "adjustable";
    case "alert" :
        return "alert";
    case "article" :
        return "article";
    case "banner" :
        return "banner";
    case "button" :
        return "button";
    case "checkbox" :
        return "checkbox";
    case "combobox" :
        return "combobox";
    case "complementary" :
        return "complementary";
    case "contentinfo" :
        return "contentinfo";
    case "form" :
        return "form";
    case "header" :
        return "header";
    case "image" :
        return "image";
    case "imagebutton" :
        return "imagebutton";
    case "keyboardkey" :
        return "keyboardkey";
    case "link" :
        return "link";
    case "list" :
        return "list";
    case "listitem" :
        return "listitem";
    case "main" :
        return "main";
    case "menu" :
        return "menu";
    case "menubar" :
        return "menubar";
    case "menuitem" :
        return "menuitem";
    case "navigation" :
        return "navigation";
    case "none" :
        return "none";
    case "progressbar" :
        return "progressbar";
    case "radio" :
        return "radio";
    case "radiogroup" :
        return "radiogroup";
    case "region" :
        return "region";
    case "scrollbar" :
        return "scrollbar";
    case "search" :
        return "search";
    case "spinbutton" :
        return "spinbutton";
    case "summary" :
        return "summary";
    case "tab" :
        return "tab";
    case "tabbar" :
        return "tabbar";
    case "tablist" :
        return "tablist";
    case "text" :
        return "text";
    case "timer" :
        return "timer";
    case "togglebutton" :
        return "togglebutton";
    case "toolbar" :
        return "toolbar";
    default:
      return ;
  }
}

function fromStringOpt$12(__x) {
  return Core__Option.flatMap(__x, fromString$12);
}

var AccessibilityRole = {
  fromString: fromString$12,
  fromStringOpt: fromStringOpt$12
};

function fromBool(checked) {
  if (checked) {
    return true;
  } else {
    return false;
  }
}

function fromBoolOpt(__x) {
  return Core__Option.map(__x, fromBool);
}

var AccessibilityStateChecked = {
  fromBool: fromBool,
  fromBoolOpt: fromBoolOpt
};

var Props = {
  EllipsizeMode: EllipsizeMode,
  AccessibilityRole: AccessibilityRole,
  AccessibilityStateChecked: AccessibilityStateChecked
};

var Style = {
  Size: Size,
  AlignItems: AlignItems,
  AlignSelf: AlignSelf,
  FontWeight: FontWeight,
  TextDecorationLine: TextDecorationLine,
  JustifyContent: JustifyContent,
  FlexDirection: FlexDirection,
  TextAlign: TextAlign,
  BorderStyle: BorderStyle,
  Position: Position,
  TextTransform: TextTransform,
  FlexWrap: FlexWrap,
  sizing: sizing,
  padding: padding,
  margin: margin,
  border: border,
  position: position,
  flex: flex,
  background: background,
  font: font
};

export {
  Style ,
  Props ,
}
/* No side effect */
